import { Collapse, Typography, Button, Space } from "antd";
import { DrawerModal, DrawerModalProps } from "../../components/DrawerModal";
import { useNavigate } from "react-router-dom";
import { AiOutlineApi } from "react-icons/ai";

export const ModalIntegrationExterior: React.FC<DrawerModalProps> = (props) => {
  const navigate = useNavigate();

  const handleNavigateToIntegrations = () => {
    navigate("/velotax/exterior-integrations?redirect=true");
  };

  return (
    <DrawerModal
      closable
      maskClosable={false}
      title="Relatórios indisponíveis"
      {...props}
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div>
          <Typography.Paragraph>
            Os seus relatórios estão indisponíveis para download. Isso pode ocorrer
            por alguns motivos:
          </Typography.Paragraph>
          
          <ol style={{ marginLeft: "16px", marginBottom: "24px" }}>
            <li>Você não realizou transações com a sua corretora do Exterior ou</li>
            <li>
              Você ainda não permitiu a conexão com uma corretora do Exterior
            </li>
          </ol>
          
          <Typography.Paragraph strong style={{ fontSize: "16px", marginBottom: "24px" }}>
            Para integrar com a Warren ou outras corretoras clique no botão abaixo.
          </Typography.Paragraph>
        </div>


        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <Button
            type="primary"
            size="large"
            icon={<AiOutlineApi style={{ verticalAlign: "middle", marginRight: "10px" }} />}
            onClick={handleNavigateToIntegrations}
            style={{
              height: "48px",
              fontSize: "16px",
              padding: "0 32px",
              borderRadius: "8px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Conecte com suas corretoras
          </Button>
        </div>

       
      </Space>
    </DrawerModal>
  );
};
